import * as CsrHttpService from '@http/csr-http.service';
import * as SsrHttpService from '@http/ssr-http.service';
import { hasWindow } from '@services/http.service';
import { ADMIN_HOME_PAGE_DISPLAY_DEALS, GET_NON_HOME_PAGE_DEALS, INVESTORS_HOME_PAGE_DISPLAY_DEALS } from './urls/homePageDeals';

export const getHomePageDeals = (ctx = null) => {
    if (hasWindow()) {
        return CsrHttpService.getWithAuth(ADMIN_HOME_PAGE_DISPLAY_DEALS());
    }
    return SsrHttpService.getWithAuth(ADMIN_HOME_PAGE_DISPLAY_DEALS(), ctx);
};

export const getHomePageDisplayDeals = (ctx = null) => {
    if (hasWindow()) {
        return CsrHttpService.getWithOutAuth(INVESTORS_HOME_PAGE_DISPLAY_DEALS());
    }
    return SsrHttpService.getWithOutAuth(INVESTORS_HOME_PAGE_DISPLAY_DEALS(), ctx);
};

export const getNoneHomePageDeals = (params = {}, ctx = null) => {
    if (hasWindow()) {
        return CsrHttpService.getWithAuth(GET_NON_HOME_PAGE_DEALS(params));
    }
    return SsrHttpService.getWithAuth(GET_NON_HOME_PAGE_DEALS(params), ctx);
};

export const updateHomePageDealsService = (body, ctx = null) => {
    const url = ADMIN_HOME_PAGE_DISPLAY_DEALS();
    if (hasWindow()) {
        return CsrHttpService.putWithAuth(url, body);
    }
    return SsrHttpService.putWithAuth(url, body, ctx);
};